<script setup lang="ts">
import { computed } from 'vue';
import { get, isNumber, isString, isObject } from 'lodash';

const props = defineProps<{
  error: Error;
}>();

function getErrorDetails(error: Error) {
  const status = get(error, 'response.status');
  const statusText = get(error, 'response.statusText');
  const data = get(error, 'response.data');

  if (isNumber(status) && isString(statusText) && isObject(data)) {
    return {
      errorHeader: `${status} ${statusText}`,
      errorMessage: get(data, 'detail', `${error.name} - ${error.message}`),
      message: null as string | null,
      stack: null as string | null | undefined,
    };
  }

  return {
    errorHeader: null as string | null,
    errorMessage: null as string | null,
    message: `${error.name} - ${error.message}`,
    stack: error.stack,
  };
}

const details = computed(() => getErrorDetails(props.error));
</script>

<template>
  <div class="app h-100 m-0">
    <div
      class="d-flex flex-column justify-content-center align-items-center vh-100 text-center"
    >
      <div v-if="details.errorHeader" class="initError">
        <div class="h2 text-danger mb-3">{{ details.errorHeader }}</div>
        <div class="lead fw-bold">{{ details.errorMessage }}</div>
      </div>

      <div v-else>
        <h2>Loading failure</h2>

        <pre v-if="details.stack">{{ details.stack }}</pre>
        <div v-else>{{ details.message }}</div>
      </div>
    </div>
  </div>
</template>
